import React, { useMemo } from 'react';
import Layout from '../../../components/common/pageLayout';
import Form from '../../../components/MasterData/Category/add'; // updated path for category form
import constant from '../../../constant';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { v3_edit_category } from '../../../actions/v3/masterData';

const EditCategory = (props) => {
    const location = useLocation();
    const { data, page } = location.state || {};
    const categoryData = useMemo(() => {
        if (!data) return null;
        if (typeof data === 'string') {
            try {
                return JSON.parse(atob(data));
            } catch (error) {
                return null;
            }
        }
        return data;
    }, [data]);

    const onSubmit = (model) => {
        if (!categoryData) {
            toast.error('Category details are missing.');
            return;
        }

        model.previousName = categoryData.CATEGORY_NAME;
        v3_edit_category(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message);
                props.history.push(constant.Authedcomponent.listCategoryMasterData.url, {
                    page: page
                });
            } else {
                toast.error(res.error);
            }
        });
    };

    return (
        <React.Fragment>
            <Layout title="Edit Category">
                <Form
                    title="Edit Category"
                    onSubmit={onSubmit}
                    data={categoryData}
                    buttonName="Save Category"
                />
            </Layout>
        </React.Fragment>
    );
};

export default EditCategory;
